
<template>
        <div style="background-color: #f8f8f8;padding-bottom: 248px;">
            <div class="container ">
                <el-button type="text" link @click="goBack()" class="btnReturn ">
                 <div class="flx-center">
                    <img style="width: 18px;height: 18px;margin-right: 5px;" :src="$ossUrl+'icons/returnOrder.png'" alt=""/>
                    <span  style="color: black;font-size: 18px;line-height: 18px;">返回</span>
                 </div>
              </el-button>
              <el-row >
                    <el-col :span="12" v-for="(item,index) in inviteList" :key="index" >
                      <div 
                          class="flx-wrap"
                          v-if="item.id === $route.query.id"
                          :class="['inviteListBox', { 'invite-active': inviteIndex === index }]"
                          @click="setInviteActive(item,index)"
                        >
                         <div class="flx-justify-between">
                           <span class="show-ellipsis">{{ item.title }}</span>
                           <span class="show-ellipsis" style="width: 115px;"><img style="padding-bottom: 5px;" :src="$ossUrl+'icons/about/invite/address.png'" alt=""> {{ item.address }}</span>
                         </div>
                         <div class="show-ellipsis">{{ item.content }}</div>
                      </div>
                    </el-col>
                  </el-row>
                  <div  v-show="showData_None" style="margin-bottom: 500px;">暂无招聘岗位</div>
            </div> 
          </div>
  </template>
  <script>
  export default {
    name:"inviteList",
    components: {
     
      // Switcher
    },
    created() {
    console.log(this.$route.query.id)

    },
    mounted(){
      this.showHidden();
    },
    data() {
      return {
        showData_None:false,
        inviteData:{},
        id:this.$route.query.id,
        inviteIndex:0,
        inviteList: [
          { id:'9',childrenId:'1', address:'深圳、东莞、广州、青岛、合肥、佛山、郑州、中山、上海、厦门、义乌',content:'大专 | 经验不限',title: '跨境物流销售'},
          { id:'9',childrenId:'2',address:'深圳',content:'大专以上学历，英语四级以上水平；| 具有FBA物流行业操作客服经验，半年以上；',title: '业务助理'},
          { id:'10',childrenId:'1',address:'深圳、长沙',content:'大专及以上学历，国际贸易，物流类相关专业优先；| 有半年/1年以上的FBA、FOB物流经验者优先；',title: '港前客服'},
          { id:'10',childrenId:'2',address:'长沙',content:'本科及以上学历，国际贸易，物流类相关专业优先；| 经验不限',title: '客服助理'},
          { id:'5',childrenId:'1',address:'长沙',content:'大专及以上学历 |  一年以上成本结算岗位的工作经验，熟练使用表格（表格使用为硬性要求）',title: '成本结算会计'},
          { id:'5',childrenId:'2',address:'长沙',content:'大专以上学历，财会相关专业毕业 |  一年以上相关岗位工作经验',title: '应收会计'},
          { id:'4',childrenId:'1',address:'深圳',content:'本科学历，英语4级以上,有国际快递或者跨境进出口行业经验，有电商经验优先考虑 | 5-10年同行业工作经验，熟悉国内市场及本行业海运市场行情，有一定船东和同行、客户资源',title: '产品经理（总监）'},
          { id:'4',childrenId:'1',address:'深圳、广州、上海、义乌',content:' 有传统货代商务/市场相关岗位2年以上工作经验或国际物流销售岗位2年以上经验；',title: '海运项目经理'},
          { id:'2',childrenId:'2',address:'深圳',content:'本科及以上学历，3年及以上欧线全程操作经验，跨境物流行业优先； ',title: '海运操作经理'},
          { id:'2',childrenId:'2',address:'深圳',content:'大专及以上学历，2年以上货代操作文件工作经验； |  英语CET4级以上，有做海外操作文件经验；',title: '海运操作'},
          { id:'3',childrenId:'1',address:'深圳',content:'本科及以上学历，进出口贸易、物流等相关专业优先，应届毕生亦可； ',title: '空运操作'},
          { id:'3',childrenId:'2',address:'深圳、长沙',content:'本科及以上学历，国际贸易，物流管理相关专业优先；',title: '2022-2024届本科生（储备干部方向）'},
          { id:'8',childrenId:'1',address:'深圳',content:'本科以上学历，物流/贸易相关专业更佳； |  3年以上客服工作经验，2年以上客服团队管理经验，超过5人以上的客服团队的管理经验优先；',title: '海外仓客服经理'},
          { id:'8',childrenId:'2',address:'深圳',content:'熟悉信息化系统，熟悉海外仓储系统，对流程开发及优化有成熟的经验（工作内容无需写代码，只需要与公司对接系统的需求即可），有相关海外仓系统经验者优先；',title: '系统运维专员'},
          { id:'8',childrenId:'3',address:'深圳',content:'本科以上学历，3年以上仓储/流行业经验 |  熟悉仓储运作流程（ToB ToC电商仓）、物流质量标准、流程优化；',title: '海外仓质控'},
        ],
      };
    },
    methods: {
        goBack() {
          this.$router.go(-1);
          localStorage.setItem('inviteIndex',JSON.stringify({index:0,activeName:'four'}));
        },
        showHidden(){
          this.showData_None = this.inviteList.every(item => {
            const isDifferent = item.id !== this.id;
            return isDifferent;
        });
        },
        setInviteActive(item,index) {
          this.inviteIndex = index
          localStorage.setItem('inviteIndex',JSON.stringify({...this.inviteData,listIndex:index}));
         this.$router.push({
           name: 'inviteListDetail',
           query:{
             id:item.id,
             childrenId:item.childrenId
           }
         });
    },
    }
    
  };
  </script>
  <style src="../index.css" scoped>


  
  
  
  
  </style>